import React, { memo, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import css from './NuevosListados.css';
import axios from "axios";
import ReactHtmlParser from 'react-html-parser';

import FloatingWindow from "../../components/ui/window/FloatingWindow";
import PDFViewer from "../../components/ui/window/PDFViewer";
import Carousel from "../../components/ui/carouselSimple/Carousel";
import { generarRutaPerfilSIC } from "../../stores/actions/rutaPerfil";

const dominio = `${window.location.protocol}//${window.location.host}`;

function NuevosListados(props) {

  let [reporteMensual, setReporteMensual] = useState(null);
  let [showPDFViewer, setShowPDFViewer] = useState(false);
  let [nuevosListadosContent, setNuevosListadosContent] = useState(null);
  let [nuevosListadosTabla, setNuevosListadosTabla] = useState([]);
  let [nuevosListadosTablaHtml, setNuevosListadosTablaHtml] = useState([]);

  let onClickReport = () => {
    setShowPDFViewer(!showPDFViewer);
  }

  async function generarRutaDetalleDeLista(lista) {
    for (let element of lista) {
      element.url = element.url || await generarRutaPerfilSIC(element.clave);
    }
    return lista;
  }

  useEffect(() => {
    let urlReporteMensual = `${dominio}/cms/o/documents/etf-bivasic-reporte-mensual/lang/${props.lang}`;
    let urlContenidoNuevosListados = `${dominio}/cms/o/documents/etf-nuevos-listados/lang/${props.lang}`;
    let urlTablaNuevosListados = `${dominio}/cms/o/documents/etf-nuevos-listados-tabla/lang/${props.lang}`;

    axios.get(urlReporteMensual)
      .then(response => {
        let pdfUrl = new URL(`${dominio}${response.data[0].url}`);
        setReporteMensual(pdfUrl.toString());
      })
      .catch(err => console.error("Error al obtener el PDF de la sección de reporte mensual. " + err.message));

    axios.get(urlContenidoNuevosListados)
      .then(response => {
        setNuevosListadosContent(response.data[0].html);
      })
      .catch(err => console.error("Error al obtener el contenido de la sección de nuevos listados. " + err.message));

    axios.get(urlTablaNuevosListados)
      .then(response => {
        return generarRutaDetalleDeLista(response.data);
      }).then(response => {
        setNuevosListadosTabla(response);
      })
      .catch(err => console.error("Error al obtener el contenido de la tabla de nuevos listados. " + err.message));
  }, []);

  useEffect(() => {
    let tmpNuevosListadosTablaHtml = [];
    nuevosListadosTabla.map((nuevoListado, index) => {
      tmpNuevosListadosTablaHtml.push(
        <>
          <table>
            <tbody>
              <tr><th>Empresa</th><td>{nuevoListado.empresa}</td></tr>
              <tr><th>País de Origen</th><td>{nuevoListado.paisOrigen}</td></tr>
              <tr><th>Bolsa donde Cotizan los Valores</th><td>{nuevoListado.bolsa}</td></tr>
              <tr><th>Moneda</th><td>{nuevoListado.moneda}</td></tr>
              <tr><th>ISIN</th><td>{nuevoListado.isin}</td></tr>
              <tr><th>Tipo de Valor</th><td>{nuevoListado.tipoValor}</td></tr>
              <tr><th>Clave</th><td>{nuevoListado.clave}</td></tr>
              <tr><th>Serie</th><td>{nuevoListado.serie}</td></tr>
              <tr><th>Tipo</th><td>{nuevoListado.tipo}</td></tr>
            </tbody>
          </table>
          <button className={css.btn_detalle} onClick={() => window.open(nuevoListado.url, "_blank")} >
            <span className={`${css.btn_detalle__icon_wrapper}`}>
              <svg viewBox="0 0 14 15" fill="none" width="10" xmlns="http://www.w3.org/2000/svg"
                className={`${css.btn_detalle__icon_svg}`} >
                <path d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  fill="currentColor"
                ></path>
              </svg>
              <svg viewBox="0 0 14 15" fill="none" width="10" xmlns="http://www.w3.org/2000/svg"
                className={`${css.btn_detalle__icon_svg} ${css.btn_detalle__icon_svg__copy}`} >
                <path d="M13.376 11.552l-.264-10.44-10.44-.24.024 2.28 6.96-.048L.2 12.56l1.488 1.488 9.432-9.432-.048 6.912 2.304.024z"
                  fill="currentColor"
                ></path>
              </svg>
            </span>
            {props.lang === "es" ? "Más información" : "More information"}
          </button>
        </>
      );
    })
    setNuevosListadosTablaHtml(tmpNuevosListadosTablaHtml);
  }, [nuevosListadosTabla]);

  return (
    <div>
      <div className={css.nuevosListadosContent}>
        <div className={`col-12 row ${css.container_table} sin_padding`}>
          {ReactHtmlParser(nuevosListadosContent)}
          {nuevosListadosTabla ?
            <div className={`col-12 row ${css.container_carousel}`}>
              <Carousel slides={nuevosListadosTablaHtml} secondsToChange={10} />
            </div>
            : ""}
        </div>
        <div className={[css.container_btn_reporte, "col-12 row"].join(" ")}>
          <button className={css.btn_reporte} onClick={onClickReport}>
            {props.lang === "es" ? "Reporte Mensual" : "Monthly Report"} <i className="fa fa-file" aria-hidden="true" />
          </button>
        </div>
      </div>

      {
        showPDFViewer ?
          <FloatingWindow show={showPDFViewer} closeWindowAction={onClickReport}
            content={
              <div className={[css.pdf_viewer, "row col-12"].join(" ")}>
                <PDFViewer url={reporteMensual} locale={props.lang} />
              </div>
            }
          /> : null
        }
    </div>
  );
}

NuevosListados.propTypes = {
    lang: PropTypes.string
}

export default memo(NuevosListados);
